// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backDropDiv {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: var(--ion-background-color);
  opacity: 0.6;
  z-index: 1000;
  width: 100%;
  height: 100%;
}

.popupDiv {
  /* position: absolute;
  top: calc((100vh - 333px) / 2);
  background-color: black;
  width: 90%;
  left: 5%;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  justify-content: space-evenly;
  color: white;
  z-index: 1000; */
  position: absolute;
  /* top: calc((100vh - 333px) / 2); */
  background-color: var(--orwi-modal-background);
  /* width: 90%; */
  /* left: 5%; */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  justify-content: space-evenly;
  z-index: 1000;
  top: 0px;
  background-color: rgba(255, 255, 255, 0.5);
  background-color: var(--orwi-dialog-color);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  height: 100%;
}

.gsm {
  /*     border-radius: 4px;
      --color: black;
      --background: white;
      --padding-start: 10px;
      text-align: center; */
}

.btn1 {
  --background: var(--ion-color-primary) !important;
}

.top {
  top: 0px;
  box-shadow: var(--orwi-modal-top-shadow);
}`, "",{"version":3,"sources":["webpack://./src/app/payment/components/otp-validation/otp-validation.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACI;;;;;;;;;;;;kBAAA;EAeA,kBAAA;EACA,oCAAA;EACA,8CAAA;EACA,gBAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;EAEA,aAAA;EACA,QAAA;EAEA,0CAAA;EACA,0CAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;AALJ;;AASA;EACA;;;;2BAAA;AAFA;;AASA;EACI,iDAAA;AANJ;;AASA;EACI,QAAA;EACA,wCAAA;AANJ","sourcesContent":[".backDropDiv {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: var(--ion-background-color);\n    opacity: 0.6;\n    z-index: 1000;\n    width: 100%;\n    height: 100%;\n\n}\n\n.popupDiv {\n    /* position: absolute;\n    top: calc((100vh - 333px) / 2);\n    background-color: black;\n    width: 90%;\n    left: 5%;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 100;\n    justify-content: space-evenly;\n    color: white;\n    z-index: 1000; */\n\n\n    position: absolute;\n    /* top: calc((100vh - 333px) / 2); */\n    background-color: var(--orwi-modal-background);\n    /* width: 90%; */\n    /* left: 5%; */\n    //border-radius: 0px 0px 30px 30px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 100;\n    justify-content: space-evenly;\n    //color: white;\n    z-index: 1000;\n    top: 0px;\n\n    background-color: rgba(255,255,255,0.5);\n    background-color: var(--orwi-dialog-color);\n    backdrop-filter: blur(15px);\n    height: 100%\n    \n}\n\n.gsm {\n/*     border-radius: 4px;\n    --color: black;\n    --background: white;\n    --padding-start: 10px;\n    text-align: center; */\n}\n\n.btn1 {\n    --background: var(--ion-color-primary) !important;\n}\n\n.top {\n    top : 0px;\n    box-shadow: var(--orwi-modal-top-shadow);\n    //border-radius: 0px 0px 30px 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
